import {i18n} from '@/plugins/i18n'

export const applicationStatus = {
    PENDING:  1,
    ACTIVE:   2,
    DISABLE:  3,
    REJECTED: 4
};

export const allApplicationStatuses = [
    applicationStatus.PENDING,
    applicationStatus.ACTIVE,
    applicationStatus.DISABLE,
    applicationStatus.REJECTED
]


export const applicationStatusStr = {
    PENDING: i18n.t('application.status.pending'),
    ACTIVE: i18n.t('application.status.active'),
    DISABLE: i18n.t('application.status.disable'),
    REJECTED: i18n.t('application.status.rejected'),

    get(status) {
        let status_str = null;

        Object.keys(applicationStatus).forEach(item => {
            if (applicationStatus[item] === status) {
                status_str = applicationStatusStr[item];
            }
        });

        return status_str;
    }
};

export const applicationStatusVariant = (status) => {
    if (status === applicationStatus.ACTIVE) {
        return 'success';
    }

    if (status === applicationStatus.PENDING) {
        return 'warning';
    }

    if (status === applicationStatus.REJECTED) {
        return 'danger';
    }

    if (status === applicationStatus.DISABLE) {
        return 'dark';
    }

    return 'secondary';
};
